<!-- sidebar.component.html -->
<div
  class="sidebar-wrapper"
  [ngClass]="theme ? 'dark-theme' : 'light-theme'"
>
  <ng-container *ngIf="!isLoggingOut; else loggingOutSidebar">
    <div class="sidebar-toggle-row">
      <button nz-button nzType="primary" type="button" (click)="toggleCollapsed()">
        <span nz-icon [nzType]="isCollapsed ? 'menu-unfold' : 'menu-fold'"></span>
      </button>
    </div>
    <ul
      nz-menu
      nzMode="inline"
      [nzInlineCollapsed]="isCollapsed"
      [nzTheme]="theme ? 'dark' : 'light'"
    >
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('DASHBOARD.TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/dashboard']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.dashboard.read')"
    >
      <span nz-icon nzType="dashboard"></span>
      <span>{{ 'DASHBOARD.TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('PROPERTY_LIST.TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/properties']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.properties.read')">
      <span nz-icon nzType="home"></span>
      <span>{{ 'PROPERTY_LIST.TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('COMPANY_PAGE.TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/company']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.company_profile.read')"
    >
      <span nz-icon nzType="bank"></span>
      <span>{{ 'COMPANY_PAGE.TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('QR_POSTER_TEMPLATE.MENU' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/qr-poster-template']"
        [nzSelected]="isQrPosterTemplateActive"
        [attr.aria-label]="('QR_POSTER_TEMPLATE.MENU' | translate) + ' — ' + ('QR_POSTER_TEMPLATE.NEW_BADGE' | translate)"
        *ngIf="userRole !== 'Admin' && hasPermission('company.qr_poster_texts.read')"
    >
      <span nz-icon nzType="file-text" class="qr-poster-menu-icon" aria-hidden="true"></span>
      <span>{{ 'QR_POSTER_TEMPLATE.MENU' | translate }}</span>
      <span class="qr-poster-menu-new-badge" aria-hidden="true">{{ 'QR_POSTER_TEMPLATE.NEW_BADGE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('CONTACTS.TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/contacts']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.contacts.read') && isEmergencyMode"
    >
      <span nz-icon nzType="contacts"></span>
      <span>{{ 'CONTACTS.TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.ANNOUNCEMENTS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/announcements']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.announcements.read')"
    >
      <span nz-icon nzType="notification"></span>
      <span>{{ 'ADMIN.ANNOUNCEMENTS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('AUDIT_LOGS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/audit-logs']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.audit_logs.read')"
    >
      <span nz-icon nzType="history"></span>
      <span>{{ 'AUDIT_LOGS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        [routerLink]="['/company/integrations']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin'"
    >
      <span nz-icon nzType="api"></span>
      <span>{{ 'INTEGRATION.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('RATING_OVERVIEW.NAV_TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/rating-overview']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin' && hasPermission('company.ratings.read') && isHospitalityMode"
    >
      <span nz-icon nzType="message"></span>
      <span>{{ 'RATING_OVERVIEW.NAV_TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('HOSPITALITY_AI.NAV_TITLE' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/hospitality-ai']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="(hasPermission('company.hospitality_ai.read') && isHospitalityMode) || userRole === 'Admin'"
    >
      <span nz-icon nzType="robot"></span>
      <span>{{ 'HOSPITALITY_AI.NAV_TITLE' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ACCOUNT_SETTINGS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        [routerLink]="['/account/settings/account']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
        *ngIf="userRole !== 'Admin'"
    >
      <span nz-icon nzType="setting"></span>
      <span>{{ 'ACCOUNT_SETTINGS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.DASHBOARD.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/dashboard']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="dashboard"></span>
      <span>{{ 'ADMIN.DASHBOARD.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.SEATS_RBAC.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/seats-rbac']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="team"></span>
      <span>{{ 'ADMIN.SEATS_RBAC.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.INTEGRATIONS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/integrations']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="api"></span>
      <span>{{ 'ADMIN.INTEGRATIONS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.EMAIL_CAMPAIGNS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/email-campaigns']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="mail"></span>
      <span>{{ 'ADMIN.EMAIL_CAMPAIGNS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.NOTIFICATIONS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/notifications']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="false"
    >
      <span nz-icon nzType="bell"></span>
      <span>{{ 'ADMIN.NOTIFICATIONS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.PLATFORM_ANNOUNCEMENTS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/platform-announcements']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="false"
    >
      <span nz-icon nzType="notification"></span>
      <span>{{ 'ADMIN.PLATFORM_ANNOUNCEMENTS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.SUPPORT_CENTER.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/support-center']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="customer-service"></span>
      <span>{{ 'ADMIN.SUPPORT_CENTER.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.USER_MANAGEMENT.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/user-management']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="user"></span>
      <span>{{ 'ADMIN.USER_MANAGEMENT.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.ACCOUNT_SECURITY.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/account/security']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="safety"></span>
      <span>{{ 'ADMIN.ACCOUNT_SECURITY.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.LOGS.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/log-management']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="bug"></span>
      <span>{{ 'ADMIN.LOGS.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.KB.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/knowledge-base']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="book"></span>
      <span>{{ 'ADMIN.KB.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        nz-tooltip
        [nzTooltipTitle]="isCollapsed ? ('ADMIN.FEEDBACK.MENU' | translate) : null"
        nzTooltipPlacement="right"
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/sign-orders']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="shopping"></span>
      <span>{{ 'SIGN_ORDER.ADMIN.MENU' | translate }}</span>
    </li>
    <li nz-menu-item
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/sign-orders/settings']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="setting"></span>
      <span>{{ 'SIGN_ORDER.ADMIN.MENU_SETTINGS' | translate }}</span>
    </li>
    <li nz-menu-item
        *ngIf="userRole === 'Admin'"
        [routerLink]="['admin/feedback']"
        [nzMatchRouter]="true"
        [nzMatchRouterExact]="true"
    >
      <span nz-icon nzType="message"></span>
      <span>{{ 'ADMIN.FEEDBACK.MENU' | translate }}</span>
    </li>
  </ul>
  </ng-container>

  <ng-template #loggingOutSidebar>
    <div class="sidebar-logout-state">
      <span nz-icon nzType="loading" nzTheme="outline"></span>
      <span>{{ 'LOGIN.LOGGING_OUT' | translate }}</span>
    </div>
  </ng-template>
</div>
